import { cn } from '@mntn-dev/ui-utilities'

import { Icon } from '../icon/icon.tsx'
import { useFormFieldContext } from './use-form-field.ts'

type FormFieldErrorProps = React.PropsWithChildren<{
  noWrap?: boolean
}>

const FormFieldError = ({ children, noWrap = false }: FormFieldErrorProps) => {
  const context = useFormFieldContext()

  if (!context?.hasError) {
    return null
  }

  const errorProps = context?.getErrorProps() ?? {}

  return (
    <div className="flex gap-1 items-center">
      <Icon name="error-warning" color="negative" fill="solid" size="sm" />
      <p
        {...errorProps}
        className={cn(
          'text-primary-red text-sm',
          ...(noWrap ? ['whitespace-nowrap'] : [])
        )}
      >
        {children}
      </p>
    </div>
  )
}

export { FormFieldError, type FormFieldErrorProps }
